import { SpecifierName } from '@gin-betting/constants';
import { View } from '@gin-betting/core';
import { find, isNaN } from 'lodash';

const getTitle = (
    market: View.Market | null,
    { name, id: currOddId }: View.Odd
): string => {
    if (!market) return name;

    const { specifiers, odds } = market;

    const hcpSpecifier = find(specifiers, s => s.name === SpecifierName.hcp);

    if (hcpSpecifier) {
        const isHome = odds[0] === currOddId;

        const { value: valueStr } = hcpSpecifier;

        const value = isHome ? +valueStr : -+valueStr;

        const symbol = value > 0 ? '+' : '';

        if (isNaN(value)) {
            return valueStr;
        }

        return `${symbol}${value}`;
    }

    return name;
};

export default getTitle;
